import React from 'react'
import { Redirect } from "react-router-dom";

// Main "SaaS One Page"
const SaasOnepage = React.lazy(() => import("../pages/Saas Onepage/index"));
const PrivacyPolicy = React.lazy(() => import("../pages/Privacy/PrivacyPolicy"));

// Special / Error Pages
const PageError = React.lazy(() => import("../pages/Special/PageError"));

const routes = [
  // SaaS One Page as the main entry
  { path: "/", exact: true, component: SaasOnepage, isTopbarDark: true },
  
  // Error page
  { path: "/page-error", component: PageError, isWithoutLayout: true },

  // Privacy Policy
  { path: "/privacy-policy", component: PrivacyPolicy },

  // Redirect index to root
  {
    path: "/index",
    component: () => <Redirect to="/" />,
  },

  // Catch-all for 404s (optional, but good practice)
  {
    path: "*",
    component: () => <Redirect to="/page-error" />,
  }
];

export default routes;
